export class LeavingFromDeskActionSettings {
    static $inject = ['init'];
    constructor(init) {
        Object.assign(this, init);
    }
}
